import { CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatIconModule } from "@angular/material/icon";
import { TicketsInfo } from "@models/tickets-info";
import { DashboardCardComponent } from "@shared/components/cards/dashboard-card/dashboard-card.component";
import { SkeletonModule } from "primeng/skeleton";
import { Subject } from "rxjs";
import { TicketInfoCardComponent } from "./ticket-info-card/ticket-info-card.component";

@Component({
    selector: "app-tickets-info-card",
    imports: [
        DashboardCardComponent,
        CommonModule,
        MatIconModule,
        MatButtonToggleModule,
        SkeletonModule,
        ReactiveFormsModule,
        TicketInfoCardComponent,
    ],
    templateUrl: "./tickets-info-card.component.html",
    styleUrl: "./tickets-info-card.component.scss"
})
export class TicketsInfoCardComponent implements OnInit, OnDestroy {
  @Input() ticketsInfo: TicketsInfo | null = null;

  @Output() selectedIntervalChanged = new EventEmitter<string>();

  daysInterval = new FormControl({
    value: "M",
    disabled: false,
  });

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.subscribeToDaysInterval();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private subscribeToDaysInterval() {
    this.daysInterval.valueChanges.subscribe((value) => {
      if (value) this.selectedIntervalChanged.emit(value);
    });
  }
}
